var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"font-weight-light",attrs:{"absolute":"","app":""}},[_c('v-col',{staticClass:"text-left",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Tarkenton Companies. All Rights Reserved ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }